import {
  configureStore as toolkitConfigureStore,
  isPlain,
} from '@reduxjs/toolkit';
import { history } from 'app/store/browserHistory';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'app/store/rootReducer';
import SagaManager from 'app/store/SagaManager';

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const connectedRouterMiddleware = routerMiddleware(history);

  const store = toolkitConfigureStore({
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // @ts-expect-error redux toolkit for some reason expects true only for serializableCheck
        // when it accepts these https://redux-toolkit.js.org/api/serializabilityMiddleware
        serializableCheck: {
          ignoredActions: [
            '@@session/START_SESSION',
            '@@session/RETRIEVE_ORG_SETTINGS',
          ],
          ignoredPaths: ['notes.editorState'],
          isSerializable: (value) =>
            isPlain(value) || value instanceof Date || value instanceof Set,
        },
      })
        .concat(sagaMiddleware)
        .concat(connectedRouterMiddleware),
    reducer: rootReducer,
  });

  SagaManager.startSagas(sagaMiddleware);

  return store;
};

export const store = configureStore();
export type AppDispatch = typeof store.dispatch;
